import env from "@/env.js";

const { baseApiUrl } = env;
const NETWORK_TIMEOUT_MS = 15000;
const NETWORK_ERROR_RESULT = {
  info: "ERR",
  error: "网络连接失败，请重试",
};

const fetchWithTimeout = async (url, options = {}) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), NETWORK_TIMEOUT_MS);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } finally {
    clearTimeout(timer);
  }
};

export const useFetch = () => {
  const postJson = async (path, api, body = {}) => {
    try {
      const response = await fetchWithTimeout(`${baseApiUrl}/${path}/${api}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(body),
      });
      return response.json();
    } catch (error) {
      console.warn("网络请求失败", error);
      return { ...NETWORK_ERROR_RESULT };
    }
  };

  const getJson = async (path) => {
    try {
      const response = await fetchWithTimeout(`${baseApiUrl}/${path}`, {
        credentials: "include",
      });
      return response.json();
    } catch (error) {
      console.warn("网络请求失败", error);
      return { ...NETWORK_ERROR_RESULT };
    }
  };

  return {
    postJson,
    getJson,
  };
};
